import React from 'react';
import APopover from 'antd-mobile/lib/popover';



export default class Popover extends APopover {}